import {MC} from './MC.js'

const data = {
  "form": {
    "@changed": ["boolean",	"false"],
    "@css": "string",
    "@cssClass": "string",
    "@showInvalidSummary": ["boolean", "false"],
    "@submitAction": "string",
    "@submitBehaviour": "string",
    "@submitByParent": ["boolean", "false"],
    "@submitTrigger": "string",
    "@submitTriggerIndex": "integer",
    "@submitTriggerPath": "string",
    "@unloadLocation": "string",
    "@width": "int",
    "clipboardData": {
      "type": "string",
      "text": "string",
      "data": "base64Binary"
    },
    "data": "anyType",
    "serverEvents*": {
      "type": "string",
      "key": "string",
      "itemId": "string"
    }
  },
  "audioviewer": {
    "@verticalAlignment": ["string","top",["bottom","middle","top"]],
    "@css": "string",
    "@cssClass": "string",
    "@cssClassField": "string",
    "@cssField": "string",
    "@data": "anyType",
    "@dragEnterDelay": ["integer","0"],
    "@dragImage": "string",
    "@dragOverDelay": ["integer","0"],
    "@draggable": ["boolean","false"],
    "@droppable": ["boolean","false"],
    "@enabled": ["boolean","true"],
    "@escapeHtml": ["boolean","true"],
    "@escapeTitleHtml": ["boolean","true"],
    "@escapeTooltipHtml": ["boolean","true"],
    "@help": "string",
    "@helpDisplay": ["string","conditional",["yes","conditional","no"]],
    "@invalid": ["boolean","false"],
    "@invalidState": ["string","error",["error","warning"]],
    "@invalidmessage": "string",
    "@tooltip": "string",
    "@tooltipDelay": "integer",
    "@visible": ["boolean","true"],
    "validation": {
      "@title": "string",
      "@forceValidation": ["boolean","false"],
      "@disableValidation": ["boolean","false"]
    },
    "@title": "string",
    "@titlePlacement": ["string","UL",["UL","L","LL","INV"]],
    "@titleWidth": "int",
    "@fileName": "string",
    "@showAsLink": ["boolean","false"],
    "@url": "string",
    "value": "base64Binary",
    "@autoplay": ["boolean","false"],
    "@contentType": "string",
    "@controls": ["boolean","true"],
    "@loop": ["boolean","false"],
    "@muted": ["boolean","false"]
  },
  "breadcrumb": {
    "@verticalAlignment": ["string","top",["bottom","middle","top"]],
    "@css": "string",
    "@cssClass": "string",
    "@cssClassField": "string",
    "@cssField": "string",
    "@data": "anyType",
    "@dragEnterDelay": ["integer","0"],
    "@dragImage": "string",
    "@dragOverDelay": ["integer","0"],
    "@draggable": ["boolean","false"],
    "@droppable": ["boolean","false"],
    "@enabled": ["boolean","true"],
    "@escapeHtml": ["boolean","true"],
    "@escapeTitleHtml": ["boolean","true"],
    "@escapeTooltipHtml": ["boolean","true"],
    "@help": "string",
    "@helpDisplay": ["string","conditional",["yes","conditional","no"]],
    "@invalid": ["boolean","false"],
    "@invalidState": ["string","error",["error","warning"]],
    "@invalidmessage": "string",
    "@tooltip": "string",
    "@tooltipDelay": "integer",
    "@visible": ["boolean","true"],
    "validation": {
      "@title": "string",
      "@forceValidation": ["boolean","false"],
      "@disableValidation": ["boolean","false"]
    },
    "@title": "string",
    "@titlePlacement": ["string","INV",["UL","L","LL","INV"]],
    "@titleWidth": "int",
    "items*": {
      "title": "string",
      "url": "string"
    }
  },
  "button": {
    "@verticalAlignment": ["string","top",["bottom","middle","top"]],
    "@css": "string",
    "@cssClass": "string",
    "@cssClassField": "string",
    "@cssField": "string",
    "@data": "anyType",
    "@dragEnterDelay": ["integer","0"],
    "@dragImage": "string",
    "@dragOverDelay": ["integer","0"],
    "@draggable": ["boolean","false"],
    "@droppable": ["boolean","false"],
    "@enabled": ["boolean","true"],
    "@escapeHtml": ["boolean","true"],
    "@escapeTitleHtml": ["boolean","true"],
    "@escapeTooltipHtml": ["boolean","true"],
    "@help": "string",
    "@helpDisplay": ["string","conditional",["yes","conditional","no"]],
    "@invalid": ["boolean","false"],
    "@invalidState": ["string","error",["error","warning"]],
    "@invalidmessage": "string",
    "@tooltip": "string",
    "@tooltipDelay": "integer",
    "@visible": ["boolean","true"],
    "validation": {
      "@title": "string",
      "@forceValidation": ["boolean","false"],
      "@disableValidation": ["boolean","false"]
    },
    "@focused": ["boolean","false"],
    "@horizontalAlignment": ["string",null,["left","center","right"]],
    "@title": "string",
    "@titlePlacement": ["string","INV",["UL","L","LL","INV"]],
    "@titleWidth": "int",
    "@icon": "string",
    "@iconPlacement": ["string","left",["left","right"]],
    "value": "string",
    "@behavior": ["string",null,["submit","store","cancel","formlogic","url"]],
    "@confirm": ["boolean","false"],
    "@confirmMessage": "string",
    "@defaultAction": ["boolean","false"],
    "@target": ["string",null,["blank","parent","top"]],
    "@url": "string"
  },
  "camera": {
    "@verticalAlignment": ["string","top",["bottom","middle","top"]],
    "@css": "string",
    "@cssClass": "string",
    "@cssClassField": "string",
    "@cssField": "string",
    "@data": "anyType",
    "@dragEnterDelay": ["integer","0"],
    "@dragImage": "string",
    "@dragOverDelay": ["integer","0"],
    "@draggable": ["boolean","false"],
    "@droppable": ["boolean","false"],
    "@enabled": ["boolean","true"],
    "@escapeHtml": ["boolean","true"],
    "@escapeTitleHtml": ["boolean","true"],
    "@escapeTooltipHtml": ["boolean","true"],
    "@help": "string",
    "@helpDisplay": ["string","conditional",["yes","conditional","no"]],
    "@invalid": ["boolean","false"],
    "@invalidState": ["string","error",["error","warning"]],
    "@invalidmessage": "string",
    "@tooltip": "string",
    "@tooltipDelay": "integer",
    "@visible": ["boolean","true"],
    "validation": {
      "@title": "string",
      "@forceValidation": ["boolean","false"],
      "@disableValidation": ["boolean","false"],
      "@required": ["boolean","false"]
    },
    "@readonly": ["boolean","false"],
    "@horizontalAlignment": ["string",null,["left","center","right"]],
    "value": "base64Binary",
    "@title": "string",
    "@titlePlacement": ["string","UL",["UL","L","LL","INV"]],
    "@titleWidth": "int",
    "@behavior": ["string",null,["submit","store","cancel","formlogic","url"]],
    "@confirm": ["boolean","false"],
    "@confirmMessage": "string",
    "@defaultAction": ["boolean","false"],
    "@focusArea": ["boolean","false"],
    "@focusAreaRatioHeight": ["int","3"],
    "@focusAreaRatioWidth": ["int","4"],
    "@mirrored": ["boolean","false"]
  },
  "carousel": {
    "@verticalAlignment": ["string","top",["bottom","middle","top"]],
    "@css": "string",
    "@cssClass": "string",
    "@cssClassField": "string",
    "@cssField": "string",
    "@data": "anyType",
    "@dragEnterDelay": ["integer","0"],
    "@dragImage": "string",
    "@dragOverDelay": ["integer","0"],
    "@draggable": ["boolean","false"],
    "@droppable": ["boolean","false"],
    "@enabled": ["boolean","true"],
    "@escapeHtml": ["boolean","true"],
    "@escapeTitleHtml": ["boolean","true"],
    "@escapeTooltipHtml": ["boolean","true"],
    "@help": "string",
    "@helpDisplay": ["string","conditional",["yes","conditional","no"]],
    "@invalid": ["boolean","false"],
    "@invalidState": ["string","error",["error","warning"]],
    "@invalidmessage": "string",
    "@tooltip": "string",
    "@tooltipDelay": "integer",
    "@visible": ["boolean","true"],
    "validation": {
      "@title": "string",
      "@forceValidation": ["boolean","false"],
      "@disableValidation": ["boolean","false"]
    },
    "@title": "string",
    "@titlePlacement": ["string","INV",["UL","L","LL","INV"]],
    "@titleWidth": "int",
    "@autoplay": ["boolean","false"],
    "@autoplayInterval": ["int","3"],
    "@pagingDotsPosition": ["string",null,["TopLeft","TopCenter","TopRight","CenterLeft","CenterCenter","CenterRight","BottomLeft","BottomCenter","BottomRight"]],
    "@target": ["string",null,["blank","parent","top"]],
    "@textNext": "string",
    "@textNextPosition": ["string",null,["TopLeft","TopCenter","TopRight","CenterLeft","CenterCenter","CenterRight","BottomLeft","BottomCenter","BottomRight"]],
    "@textPrev": "string",
    "@textPrevPosition": ["string",null,["TopLeft","TopCenter","TopRight","CenterLeft","CenterCenter","CenterRight","BottomLeft","BottomCenter","BottomRight"]],
    "@wrapAround": ["boolean","false"],
    "value*": {
      "@contentType": "string",
      "@url": "string",
      "@base64": "base64Binary",
      "@clickUrl": "string"
    }
  },
  "chart": {
    "@verticalAlignment": ["string","top",["bottom","middle","top"]],
    "@css": "string",
    "@cssClass": "string",
    "@cssClassField": "string",
    "@cssField": "string",
    "@data": "anyType",
    "@dragEnterDelay": ["integer","0"],
    "@dragImage": "string",
    "@dragOverDelay": ["integer","0"],
    "@draggable": ["boolean","false"],
    "@droppable": ["boolean","false"],
    "@enabled": ["boolean","true"],
    "@escapeHtml": ["boolean","true"],
    "@escapeTitleHtml": ["boolean","true"],
    "@escapeTooltipHtml": ["boolean","true"],
    "@help": "string",
    "@helpDisplay": ["string","conditional",["yes","conditional","no"]],
    "@invalid": ["boolean","false"],
    "@invalidState": ["string","error",["error","warning"]],
    "@invalidmessage": "string",
    "@tooltip": "string",
    "@tooltipDelay": "integer",
    "@visible": ["boolean","true"],
    "validation": {
      "@title": "string",
      "@forceValidation": ["boolean","false"],
      "@disableValidation": ["boolean","false"]
    },
    "@title": "string",
    "@titlePlacement": ["string","UL",["UL","L","LL","INV"]],
    "@titleWidth": "int",
    "@horizontal": ["boolean","false"],
    "@legendPosition": ["string",null,["top","bottom","left","right","none"]],
    "@maintainAspectRatio": ["boolean","true"],
    "@showChartTooltips": ["boolean","true"],
    "@stacked": ["boolean","false"],
    "@stacked100": ["boolean","false"],
    "@valuesInsideChart": ["boolean","false"],
    "@valuesInsideChartColor": ["string","#FFFFFF"],
    "@valuesInsideChartFontFamily": "string",
    "@valuesInsideChartFontSize": ["integer","12"],
    "@valuesInsideChartFontStyle": ["string","normal"],
    "@valuesInsideChartFontWeight": ["string","normal"],
    "@valuesInsideChartFormatter": ["string",null,["percent","message"]],
    "@valuesInsideChartHideSmallerThan": "decimal",
    "@valuesInsideChartPosition": ["string","center",["start","center","end"]],
    "@valuesInsideChartformatPattern": "string",
    "series*": {
      "@name": "string",
      "@type": "string",
      "@color": "string",
      "d*": "decimal",
      "@isSecondary": "boolean",
      "@interpolationMode": ["string",null,["default","monotone"]],
      "@fill": ["string",null,["origin","start","end"]],
      "@backgroundColor": "string"
    },
    "xAxis": {
      "c*": "string",
      "timeUnit": ["string",null,["millisecond","second","minute","hour","day","week","month","quarter","year"]],
      "timeMin": "dateTime",
      "timeMax": "dateTime",
      "gridLine": ["boolean","true"],
      "gridLineColor": "string",
      "borderLine": ["boolean","true"],
      "hide": ["boolean","false"]
    },
    "yAxis": {
      "softMin": "decimal",
      "softMax": "decimal",
      "gridLine": ["boolean","true"],
      "gridLineColor": "string",
      "borderLine": ["boolean","true"],
      "hide": ["boolean","false"]
    },
    "yAxisSecondary": {
      "softMin": "decimal",
      "softMax": "decimal",
      "gridLine": ["boolean","true"],
      "gridLineColor": "string",
      "borderLine": ["boolean","true"]
    }
  },
  "checkbox": {
    "@verticalAlignment": ["string","top",["bottom","middle","top"]],
    "@css": "string",
    "@cssClass": "string",
    "@cssClassField": "string",
    "@cssField": "string",
    "@data": "anyType",
    "@dragEnterDelay": ["integer","0"],
    "@dragImage": "string",
    "@dragOverDelay": ["integer","0"],
    "@draggable": ["boolean","false"],
    "@droppable": ["boolean","false"],
    "@enabled": ["boolean","true"],
    "@escapeHtml": ["boolean","true"],
    "@escapeTitleHtml": ["boolean","true"],
    "@escapeTooltipHtml": ["boolean","true"],
    "@help": "string",
    "@helpDisplay": ["string","conditional",["yes","conditional","no"]],
    "@invalid": ["boolean","false"],
    "@invalidState": ["string","error",["error","warning"]],
    "@invalidmessage": "string",
    "@tooltip": "string",
    "@tooltipDelay": "integer",
    "@visible": ["boolean","true"],
    "validation": {
      "@title": "string",
      "@forceValidation": ["boolean","false"],
      "@disableValidation": ["boolean","false"],
      "@required": ["boolean","false"]
    },
    "@readonly": ["boolean","false"],
    "@focused": ["boolean","false"],
    "@horizontalAlignment": ["string",null,["left","center","right"]],
    "@textmode": ["boolean","false"],
    "@title": "string",
    "@titlePlacement": ["string","R",["R","UL","L","LL","INV"]],
    "@titleWidth": "int",
    "@behavior": ["string",null,["submit","store","cancel","formlogic","url"]],
    "@confirm": ["boolean","false"],
    "@confirmMessage": "string",
    "@defaultAction": ["boolean","false"],
    "@indeterminate": ["boolean","false"],
    "value": ["boolean","false"]
  },
  "codeeditor": {
    "@verticalAlignment": ["string","top",["bottom","middle","top"]],
    "@css": "string",
    "@cssClass": "string",
    "@cssClassField": "string",
    "@cssField": "string",
    "@data": "anyType",
    "@dragEnterDelay": ["integer","0"],
    "@dragImage": "string",
    "@dragOverDelay": ["integer","0"],
    "@draggable": ["boolean","false"],
    "@droppable": ["boolean","false"],
    "@enabled": ["boolean","true"],
    "@escapeHtml": ["boolean","true"],
    "@escapeTitleHtml": ["boolean","true"],
    "@escapeTooltipHtml": ["boolean","true"],
    "@help": "string",
    "@helpDisplay": ["string","conditional",["yes","conditional","no"]],
    "@invalid": ["boolean","false"],
    "@invalidState": ["string","error",["error","warning"]],
    "@invalidmessage": "string",
    "@tooltip": "string",
    "@tooltipDelay": "integer",
    "@visible": ["boolean","true"],
    "validation": {
      "@title": "string",
      "@forceValidation": ["boolean","false"],
      "@disableValidation": ["boolean","false"],
      "@required": ["boolean","false"],
      "@minLength": "int",
      "@maxLength": "int",
      "@pattern": "string"
    },
    "@focused": ["boolean","false"],
    "value": "string",
    "@readonly": ["boolean","false"],
    "@title": "string",
    "@titlePlacement": ["string","UL",["UL","L","LL","INV"]],
    "@titleWidth": "int",
    "@contentType": "string",
    "@fitToContent": ["boolean","false"],
    "@height": "integer",
    "@hideGutter": ["boolean","false"],
    "@maxLines": "integer",
    "@minLines": "integer",
    "@placeholder": "string",
    "@printMarginSize": ["integer","80"],
    "@showPrintMargin": ["boolean","false"],
    "@wrap": ["boolean","false"]
  },
  "colorpalette": {
    "@verticalAlignment": ["string","top",["bottom","middle","top"]],
    "@css": "string",
    "@cssClass": "string",
    "@cssClassField": "string",
    "@cssField": "string",
    "@data": "anyType",
    "@dragEnterDelay": ["integer","0"],
    "@dragImage": "string",
    "@dragOverDelay": ["integer","0"],
    "@draggable": ["boolean","false"],
    "@droppable": ["boolean","false"],
    "@enabled": ["boolean","true"],
    "@escapeHtml": ["boolean","true"],
    "@escapeTitleHtml": ["boolean","true"],
    "@escapeTooltipHtml": ["boolean","true"],
    "@help": "string",
    "@helpDisplay": ["string","conditional",["yes","conditional","no"]],
    "@invalid": ["boolean","false"],
    "@invalidState": ["string","error",["error","warning"]],
    "@invalidmessage": "string",
    "@tooltip": "string",
    "@tooltipDelay": "integer",
    "@visible": ["boolean","true"],
    "validation": {
      "@title": "string",
      "@forceValidation": ["boolean","false"],
      "@disableValidation": ["boolean","false"],
      "@required": ["boolean","false"]
    },
    "@readonly": ["boolean","false"],
    "@focused": ["boolean","false"],
    "value": "string",
    "@title": "string",
    "@titlePlacement": ["string","UL",["UL","L","LL","INV"]],
    "@titleWidth": "int",
    "@textmode": ["boolean","false"],
    "@placeholder": "string",
    "@size": "integer",
    "@behavior": ["string",null,["submit","store","cancel","formlogic","url"]],
    "@confirm": ["boolean","false"],
    "@confirmMessage": "string",
    "@defaultAction": ["boolean","false"],
    "@clearable": ["boolean","false"],
    "items*": "string"
  },
  "combobox": {
    "items*": {
      "@key": "string",
      "@title": "string",
      "@group": "string",
      "@icon": "string",
      "@imageUrl": "string",
      "@url": "string",
      "@enabled": "boolean",
      "@cssClass": "string",
      "@css": "string"
    },
    "defaultItems*": {
      "@key": "string",
      "@title": "string"
    },
    "@behavior": ["string",null,["submit","store","cancel","formlogic","url"]],
    "@confirm": ["boolean","false"],
    "@confirmMessage": "string",
    "@defaultAction": ["boolean","false"],
    "@verticalAlignment": ["string","top",["bottom","middle","top"]],
    "@css": "string",
    "@cssClass": "string",
    "@cssClassField": "string",
    "@cssField": "string",
    "@data": "anyType",
    "@dragEnterDelay": ["integer","0"],
    "@dragImage": "string",
    "@dragOverDelay": ["integer","0"],
    "@draggable": ["boolean","false"],
    "@droppable": ["boolean","false"],
    "@enabled": ["boolean","true"],
    "@escapeHtml": ["boolean","true"],
    "@escapeTitleHtml": ["boolean","true"],
    "@escapeTooltipHtml": ["boolean","true"],
    "@help": "string",
    "@helpDisplay": ["string","conditional",["yes","conditional","no"]],
    "@invalid": ["boolean","false"],
    "@invalidState": ["string","error",["error","warning"]],
    "@invalidmessage": "string",
    "@tooltip": "string",
    "@tooltipDelay": "integer",
    "@visible": ["boolean","true"],
    "validation": {
      "@title": "string",
      "@forceValidation": ["boolean","false"],
      "@disableValidation": ["boolean","false"],
      "@required": ["boolean","false"]
    },
    "@readonly": ["boolean","false"],
    "@focused": ["boolean","false"],
    "@title": "string",
    "@titlePlacement": ["string","UL",["UL","L","LL","INV"]],
    "@titleWidth": "int",
    "value*": "string",
    "@placeholder": "string",
    "@textmode": ["boolean","false"],
    "@typingbreakDelay": ["integer","1000"],
    "@maxDropDownHeight": "string",
    "@allowAdditions": ["boolean","false"],
    "@clearable": ["boolean","false"],
    "@customSearch": ["boolean","false"],
    "@invalidValues": ["string","ignore",["add","mark","ignore","invalid"]],
    "@multiple": ["boolean","false"],
    "@noResultsMessage": "string",
    "@openOnFocus": ["boolean","false"],
    "@searchQuery": "string",
    "@target": ["string",null,["blank","parent","top"]],
    "@whisper": ["boolean","false"],
    "text": "string"
  },
  "datebox": {
    "@verticalAlignment": ["string","top",["bottom","middle","top"]],
    "@css": "string",
    "@cssClass": "string",
    "@cssClassField": "string",
    "@cssField": "string",
    "@data": "anyType",
    "@dragEnterDelay": ["integer","0"],
    "@dragImage": "string",
    "@dragOverDelay": ["integer","0"],
    "@draggable": ["boolean","false"],
    "@droppable": ["boolean","false"],
    "@enabled": ["boolean","true"],
    "@escapeHtml": ["boolean","true"],
    "@escapeTitleHtml": ["boolean","true"],
    "@escapeTooltipHtml": ["boolean","true"],
    "@help": "string",
    "@helpDisplay": ["string","conditional",["yes","conditional","no"]],
    "@invalid": ["boolean","false"],
    "@invalidState": ["string","error",["error","warning"]],
    "@invalidmessage": "string",
    "@tooltip": "string",
    "@tooltipDelay": "integer",
    "@visible": ["boolean","true"],
    "validation": {
      "@title": "string",
      "@forceValidation": ["boolean","false"],
      "@disableValidation": ["boolean","false"],
      "@required": ["boolean","false"],
      "@minValue": "data",
      "@maxValue": "data"
    },
    "@readonly": ["boolean","false"],
    "@focused": ["boolean","false"],
    "value": "data",
    "@title": "string",
    "@titlePlacement": ["string","UL",["UL","L","LL","INV"]],
    "@titleWidth": "int",
    "@textmode": ["boolean","false"],
    "@placeholder": "string",
    "@size": "integer",
    "@formatPattern": "string",
    "@secondaryPatterns*": "string",
    "@horizontalAlignment": ["string",null,["left","center","right"]],
    "@outputTimezone": ["boolean","false"],
    "@viewDate": "data",
    "@weekends": ["boolean","true"]
  },
  "defaultviewer": {
    "@verticalAlignment": ["string","top",["bottom","middle","top"]],
    "@css": "string",
    "@cssClass": "string",
    "@cssClassField": "string",
    "@cssField": "string",
    "@data": "anyType",
    "@dragEnterDelay": ["integer","0"],
    "@dragImage": "string",
    "@dragOverDelay": ["integer","0"],
    "@draggable": ["boolean","false"],
    "@droppable": ["boolean","false"],
    "@enabled": ["boolean","true"],
    "@escapeHtml": ["boolean","true"],
    "@escapeTitleHtml": ["boolean","true"],
    "@escapeTooltipHtml": ["boolean","true"],
    "@help": "string",
    "@helpDisplay": ["string","conditional",["yes","conditional","no"]],
    "@invalid": ["boolean","false"],
    "@invalidState": ["string","error",["error","warning"]],
    "@invalidmessage": "string",
    "@tooltip": "string",
    "@tooltipDelay": "integer",
    "@visible": ["boolean","true"],
    "validation": {
      "@title": "string",
      "@forceValidation": ["boolean","false"],
      "@disableValidation": ["boolean","false"]
    },
    "@title": "string",
    "@titlePlacement": ["string","UL",["UL","L","LL","INV"]],
    "@titleWidth": "int",
    "@fileName": "string",
    "@showAsLink": ["boolean","false"],
    "@url": "string",
    "value": "base64Binary",
    "@contentType": "string"
  },
  "divider": {
    "@icon": "string",
    "@iconPlacement": ["string","left",["left","right"]],
    "@headerType": ["string",null,["H1","H2","H3","H4","H5","H6"]],
    "@title": "string",
    "@titlePlacement": ["string","INV",["PI","UL","L","LL","INV"]],
    "@titleWidth": "int",
    "@css": "string",
    "@cssClass": "string",
    "@cssClassField": "string",
    "@cssField": "string",
    "@data": "anyType",
    "@hiddenLine": ["boolean","false"],
    "@vertical": ["boolean","false"],
    "@visible": ["boolean","true"]
  },
  "download": {
    "def:WidgetProperty": ["string","base64Binary"]
  },
  "dynamicPanel": {
    "@verticalAlignment": ["string","top",["bottom","middle","top"]],
    "@css": "string",
    "@cssClass": "string",
    "@cssClassField": "string",
    "@cssField": "string",
    "@data": "anyType",
    "@dragEnterDelay": ["integer","0"],
    "@dragImage": "string",
    "@dragOverDelay": ["integer","0"],
    "@draggable": ["boolean","false"],
    "@droppable": ["boolean","false"],
    "@enabled": ["boolean","true"],
    "@escapeHtml": ["boolean","true"],
    "@escapeTitleHtml": ["boolean","true"],
    "@escapeTooltipHtml": ["boolean","true"],
    "@help": "string",
    "@helpDisplay": ["string","conditional",["yes","conditional","no"]],
    "@invalid": ["boolean","false"],
    "@invalidState": ["string","error",["error","warning"]],
    "@invalidmessage": "string",
    "@tooltip": "string",
    "@tooltipDelay": "integer",
    "@visible": ["boolean","true"],
    "validation": {
      "@title": "string",
      "@forceValidation": ["boolean","false"],
      "@disableValidation": ["boolean","false"]
    },
    "@title": "string",
    "@titlePlacement": ["string","INV",["PI","UL","L","LL","INV"]],
    "@titleWidth": "int",
    "@textmode": ["boolean","false"],
    "fieldDefs*": "anyType",
    "fieldsData": "anyType"
  },
  "embeddeddialog": {
    "@verticalAlignment": ["string","top",["bottom","middle","top"]],
    "@css": "string",
    "@cssClass": "string",
    "@cssClassField": "string",
    "@cssField": "string",
    "@data": "anyType",
    "@dragEnterDelay": ["integer","0"],
    "@dragImage": "string",
    "@dragOverDelay": ["integer","0"],
    "@draggable": ["boolean","false"],
    "@droppable": ["boolean","false"],
    "@enabled": ["boolean","true"],
    "@escapeHtml": ["boolean","true"],
    "@escapeTitleHtml": ["boolean","true"],
    "@escapeTooltipHtml": ["boolean","true"],
    "@help": "string",
    "@helpDisplay": ["string","conditional",["yes","conditional","no"]],
    "@invalid": ["boolean","false"],
    "@invalidState": ["string","error",["error","warning"]],
    "@invalidmessage": "string",
    "@tooltip": "string",
    "@tooltipDelay": "integer",
    "@visible": ["boolean","true"],
    "validation": {
      "@title": "string",
      "@forceValidation": ["boolean","false"],
      "@disableValidation": ["boolean","false"]
    },
    "@collapsed": ["boolean","false"],
    "@collapsible": ["boolean","false"],
    "@focused": ["boolean","false"],
    "@title": "string",
    "@titlePlacement": ["string","UL",["UL","L","LL","INV"]],
    "@titleWidth": "int",
    "value": "string",
    "@dataActionAutoLoad": ["boolean","false"],
    "@dataEvent": "string",
    "@debug": ["string",null,["AUTO","MINIMAL","BASIC","DETAIL","TRACE"]],
    "@debugConsole": ["boolean","true"],
    "@loader": ["string","all",["all","init","none"]],
    "@reload": ["boolean","false"],
    "@submitByParent": ["boolean","false"]
  },
  "hbox": {
    "@verticalAlignment": ["string","top",["bottom","middle","top"]],
    "@css": "string",
    "@cssClass": "string",
    "@cssClassField": "string",
    "@cssField": "string",
    "@data": "anyType",
    "@dragEnterDelay": ["integer","0"],
    "@dragImage": "string",
    "@dragOverDelay": ["integer","0"],
    "@draggable": ["boolean","false"],
    "@droppable": ["boolean","false"],
    "@enabled": ["boolean","true"],
    "@escapeHtml": ["boolean","true"],
    "@escapeTitleHtml": ["boolean","true"],
    "@escapeTooltipHtml": ["boolean","true"],
    "@help": "string",
    "@helpDisplay": ["string","conditional",["yes","conditional","no"]],
    "@invalid": ["boolean","false"],
    "@invalidState": ["string","error",["error","warning"]],
    "@invalidmessage": "string",
    "@tooltip": "string",
    "@tooltipDelay": "integer",
    "@visible": ["boolean","true"],
    "validation": {
      "@title": "string",
      "@forceValidation": ["boolean","false"],
      "@disableValidation": ["boolean","false"]
    },
    "@collapsed": ["boolean","false"],
    "@collapsible": ["boolean","false"],
    "@horizontalAlignment": ["string",null,["left","center","right"]],
    "@readonly": ["boolean","false"],
    "@title": "string",
    "@titlePlacement": ["string","UL",["UL","L","LL","INV"]],
    "@titleWidth": "int",
    "@textmode": ["boolean","false"],
    "@fitWidth": ["boolean","false"],
    "@grouped": ["boolean","false"]
  },
  "htmleditor": {
    "@verticalAlignment": ["string","top",["bottom","middle","top"]],
    "@css": "string",
    "@cssClass": "string",
    "@cssClassField": "string",
    "@cssField": "string",
    "@data": "anyType",
    "@dragEnterDelay": ["integer","0"],
    "@dragImage": "string",
    "@dragOverDelay": ["integer","0"],
    "@draggable": ["boolean","false"],
    "@droppable": ["boolean","false"],
    "@enabled": ["boolean","true"],
    "@escapeHtml": ["boolean","true"],
    "@escapeTitleHtml": ["boolean","true"],
    "@escapeTooltipHtml": ["boolean","true"],
    "@help": "string",
    "@helpDisplay": ["string","conditional",["yes","conditional","no"]],
    "@invalid": ["boolean","false"],
    "@invalidState": ["string","error",["error","warning"]],
    "@invalidmessage": "string",
    "@tooltip": "string",
    "@tooltipDelay": "integer",
    "@visible": ["boolean","true"],
    "validation": {
      "@title": "string",
      "@forceValidation": ["boolean","false"],
      "@disableValidation": ["boolean","false"],
      "@required": ["boolean","false"],
      "@minLength": "int",
      "@maxLength": "int",
      "@pattern": "string"
    },
    "value": "string",
    "@readonly": ["boolean","false"],
    "@title": "string",
    "@titlePlacement": ["string","UL",["UL","L","LL","INV"]],
    "@titleWidth": "int",
    "@height": "integer",
    "@placeholder": "string"
  },
  "icon": {
    "@verticalAlignment": ["string","top",["bottom","middle","top"]],
    "@css": "string",
    "@cssClass": "string",
    "@cssClassField": "string",
    "@cssField": "string",
    "@data": "anyType",
    "@dragEnterDelay": ["integer","0"],
    "@dragImage": "string",
    "@dragOverDelay": ["integer","0"],
    "@draggable": ["boolean","false"],
    "@droppable": ["boolean","false"],
    "@enabled": ["boolean","true"],
    "@escapeHtml": ["boolean","true"],
    "@escapeTitleHtml": ["boolean","true"],
    "@escapeTooltipHtml": ["boolean","true"],
    "@help": "string",
    "@helpDisplay": ["string","conditional",["yes","conditional","no"]],
    "@invalid": ["boolean","false"],
    "@invalidState": ["string","error",["error","warning"]],
    "@invalidmessage": "string",
    "@tooltip": "string",
    "@tooltipDelay": "integer",
    "@visible": ["boolean","true"],
    "validation": {
      "@title": "string",
      "@forceValidation": ["boolean","false"],
      "@disableValidation": ["boolean","false"]
    },
    "@horizontalAlignment": ["string",null,["left","center","right"]],
    "@title": "string",
    "@titlePlacement": ["string","INV",["UL","L","LL","INV"]],
    "@titleWidth": "int",
    "@icon": "string",
    "@iconPlacement": ["string","left",["left","right"]]
  },
  "iframe": {
    "@title": "string",
    "@titlePlacement": ["string","UL",["UL","L","LL","INV"]],
    "@titleWidth": "int",
    "@verticalAlignment": ["string","top",["bottom","middle","top"]],
    "@css": "string",
    "@cssClass": "string",
    "@cssClassField": "string",
    "@cssField": "string",
    "@data": "anyType",
    "@dragEnterDelay": ["integer","0"],
    "@dragImage": "string",
    "@dragOverDelay": ["integer","0"],
    "@draggable": ["boolean","false"],
    "@droppable": ["boolean","false"],
    "@enabled": ["boolean","true"],
    "@escapeHtml": ["boolean","true"],
    "@escapeTitleHtml": ["boolean","true"],
    "@escapeTooltipHtml": ["boolean","true"],
    "@help": "string",
    "@helpDisplay": ["string","conditional",["yes","conditional","no"]],
    "@invalid": ["boolean","false"],
    "@invalidState": ["string","error",["error","warning"]],
    "@invalidmessage": "string",
    "@tooltip": "string",
    "@tooltipDelay": "integer",
    "@visible": ["boolean","true"],
    "validation": {
      "@title": "string",
      "@forceValidation": ["boolean","false"],
      "@disableValidation": ["boolean","false"]
    },
    "@allow": "string",
    "@allowFullScreen": ["boolean","false"],
    "@fitContentSelector": "string",
    "@fitHeightWithContent": ["boolean","false"],
    "@height": "string",
    "@id": "string",
    "@referrerpolicy": "string",
    "@sandbox": "string",
    "@url": "string"
  },
  "imageviewer": {
    "@verticalAlignment": ["string","top",["bottom","middle","top"]],
    "@css": "string",
    "@cssClass": "string",
    "@cssClassField": "string",
    "@cssField": "string",
    "@data": "anyType",
    "@dragEnterDelay": ["integer","0"],
    "@dragImage": "string",
    "@dragOverDelay": ["integer","0"],
    "@draggable": ["boolean","false"],
    "@droppable": ["boolean","false"],
    "@enabled": ["boolean","true"],
    "@escapeHtml": ["boolean","true"],
    "@escapeTitleHtml": ["boolean","true"],
    "@escapeTooltipHtml": ["boolean","true"],
    "@help": "string",
    "@helpDisplay": ["string","conditional",["yes","conditional","no"]],
    "@invalid": ["boolean","false"],
    "@invalidState": ["string","error",["error","warning"]],
    "@invalidmessage": "string",
    "@tooltip": "string",
    "@tooltipDelay": "integer",
    "@visible": ["boolean","true"],
    "validation": {
      "@title": "string",
      "@forceValidation": ["boolean","false"],
      "@disableValidation": ["boolean","false"]
    },
    "@title": "string",
    "@titlePlacement": ["string","UL",["UL","L","LL","INV"]],
    "@titleWidth": "int",
    "@fileName": "string",
    "@showAsLink": ["boolean","false"],
    "@url": "string",
    "value": "base64Binary",
    "@horizontalAlignment": ["string",null,["left","center","right"]],
    "@contentType": "string"
  },
  "label": {
    "@verticalAlignment": ["string","top",["bottom","middle","top"]],
    "@css": "string",
    "@cssClass": "string",
    "@cssClassField": "string",
    "@cssField": "string",
    "@data": "anyType",
    "@dragEnterDelay": ["integer","0"],
    "@dragImage": "string",
    "@dragOverDelay": ["integer","0"],
    "@draggable": ["boolean","false"],
    "@droppable": ["boolean","false"],
    "@enabled": ["boolean","true"],
    "@escapeHtml": ["boolean","true"],
    "@escapeTitleHtml": ["boolean","true"],
    "@escapeTooltipHtml": ["boolean","true"],
    "@help": "string",
    "@helpDisplay": ["string","conditional",["yes","conditional","no"]],
    "@invalid": ["boolean","false"],
    "@invalidState": ["string","error",["error","warning"]],
    "@invalidmessage": "string",
    "@tooltip": "string",
    "@tooltipDelay": "integer",
    "@visible": ["boolean","true"],
    "validation": {
      "@title": "string",
      "@forceValidation": ["boolean","false"],
      "@disableValidation": ["boolean","false"]
    },
    "@formatPattern": "string",
    "@formatType": ["string",null,["date","time","datetime","number","currency","message","percent"]],
    "@horizontalAlignment": ["string",null,["left","center","right"]],
    "@headerType": ["string",null,["H1","H2","H3","H4","H5","H6"]],
    "value": "data",
    "@title": "string",
    "@titlePlacement": ["string","INV",["UL","L","LL","INV"]],
    "@titleWidth": "int",
    "@icon": "string",
    "@iconPlacement": ["string","left",["left","right"]]
  },
  "link": {
    "@verticalAlignment": ["string","top",["bottom","middle","top"]],
    "@css": "string",
    "@cssClass": "string",
    "@cssClassField": "string",
    "@cssField": "string",
    "@data": "anyType",
    "@dragEnterDelay": ["integer","0"],
    "@dragImage": "string",
    "@dragOverDelay": ["integer","0"],
    "@draggable": ["boolean","false"],
    "@droppable": ["boolean","false"],
    "@enabled": ["boolean","true"],
    "@escapeHtml": ["boolean","true"],
    "@escapeTitleHtml": ["boolean","true"],
    "@escapeTooltipHtml": ["boolean","true"],
    "@help": "string",
    "@helpDisplay": ["string","conditional",["yes","conditional","no"]],
    "@invalid": ["boolean","false"],
    "@invalidState": ["string","error",["error","warning"]],
    "@invalidmessage": "string",
    "@tooltip": "string",
    "@tooltipDelay": "integer",
    "@visible": ["boolean","true"],
    "validation": {
      "@title": "string",
      "@forceValidation": ["boolean","false"],
      "@disableValidation": ["boolean","false"]
    },
    "@focused": ["boolean","false"],
    "@horizontalAlignment": ["string",null,["left","center","right"]],
    "@title": "string",
    "@titlePlacement": ["string","INV",["UL","L","LL","INV"]],
    "@titleWidth": "int",
    "@icon": "string",
    "@iconPlacement": ["string","left",["left","right"]],
    "@imageUrl": "string",
    "value": "string",
    "@behavior": ["string",null,["submit","store","cancel","formlogic","url"]],
    "@confirm": ["boolean","false"],
    "@confirmMessage": "string",
    "@defaultAction": ["boolean","false"],
    "@target": ["string",null,["blank","parent","top"]],
    "@url": "string"
  },
  "marked": {
    "@verticalAlignment": ["string","top",["bottom","middle","top"]],
    "@css": "string",
    "@cssClass": "string",
    "@cssClassField": "string",
    "@cssField": "string",
    "@data": "anyType",
    "@dragEnterDelay": ["integer","0"],
    "@dragImage": "string",
    "@dragOverDelay": ["integer","0"],
    "@draggable": ["boolean","false"],
    "@droppable": ["boolean","false"],
    "@enabled": ["boolean","true"],
    "@escapeHtml": ["boolean","true"],
    "@escapeTitleHtml": ["boolean","true"],
    "@escapeTooltipHtml": ["boolean","true"],
    "@help": "string",
    "@helpDisplay": ["string","conditional",["yes","conditional","no"]],
    "@invalid": ["boolean","false"],
    "@invalidState": ["string","error",["error","warning"]],
    "@invalidmessage": "string",
    "@tooltip": "string",
    "@tooltipDelay": "integer",
    "@visible": ["boolean","true"],
    "validation": {
      "@title": "string",
      "@forceValidation": ["boolean","false"],
      "@disableValidation": ["boolean","false"]
    },
    "@title": "string",
    "@titlePlacement": ["string","UL",["UL","L","LL","INV"]],
    "@titleWidth": "int",
    "value": "string",
    "@baseUrl": "string"
  },
  "menu": {
    "@fitWidth": ["boolean","false"],
    "@behavior": ["string",null,["submit","store","cancel","formlogic","url"]],
    "@confirm": ["boolean","false"],
    "@confirmMessage": "string",
    "@defaultAction": ["boolean","false"],
    "@verticalAlignment": ["string","top",["bottom","middle","top"]],
    "@css": "string",
    "@cssClass": "string",
    "@cssClassField": "string",
    "@cssField": "string",
    "@data": "anyType",
    "@dragEnterDelay": ["integer","0"],
    "@dragImage": "string",
    "@dragOverDelay": ["integer","0"],
    "@draggable": ["boolean","false"],
    "@droppable": ["boolean","false"],
    "@enabled": ["boolean","true"],
    "@escapeHtml": ["boolean","true"],
    "@escapeTitleHtml": ["boolean","true"],
    "@escapeTooltipHtml": ["boolean","true"],
    "@help": "string",
    "@helpDisplay": ["string","conditional",["yes","conditional","no"]],
    "@invalid": ["boolean","false"],
    "@invalidState": ["string","error",["error","warning"]],
    "@invalidmessage": "string",
    "@tooltip": "string",
    "@tooltipDelay": "integer",
    "@visible": ["boolean","true"],
    "validation": {
      "@title": "string",
      "@forceValidation": ["boolean","false"],
      "@disableValidation": ["boolean","false"]
    },
    "@title": "string",
    "@titlePlacement": ["string","INV",["UL","L","LL","INV"]],
    "@titleWidth": "int",
    "@maxDropDownHeight": "string",
    "@activeKey": "string",
    "@dropdownSubMenu": ["boolean","false"],
    "@focusedKey": "string",
    "@iconPlacement": ["string","left",["left","right"]],
    "@target": ["string",null,["blank","parent","top"]],
    "@vertical": "boolean",
    "items*": {
      "key": "string",
      "title": "string",
      "icon": "string",
      "cssclass": "string",
      "css": "string",
      "url": "string",
      "tooltip": "string",
      "enabled": ["boolean","true"],
      "opened": ["boolean","false"],
      "items*": {
        "key": "string",
        "title": "string",
        "icon": "string",
        "cssclass": "string",
        "css": "string",
        "url": "string",
        "tooltip": "string",
        "enabled": ["boolean","true"],
        "opened": ["boolean","false"],
        "items*": {
          "key": "string",
          "title": "string",
          "icon": "string",
          "cssclass": "string",
          "css": "string",
          "url": "string",
          "tooltip": "string",
          "enabled": ["boolean","true"]
        }
      }
    }
  },
  "menutree": {
    "@fitWidth": ["boolean","false"],
    "@behavior": ["string",null,["submit","store","cancel","formlogic","url"]],
    "@confirm": ["boolean","false"],
    "@confirmMessage": "string",
    "@defaultAction": ["boolean","false"],
    "@verticalAlignment": ["string","top",["bottom","middle","top"]],
    "@css": "string",
    "@cssClass": "string",
    "@cssClassField": "string",
    "@cssField": "string",
    "@data": "anyType",
    "@dragEnterDelay": ["integer","0"],
    "@dragImage": "string",
    "@dragOverDelay": ["integer","0"],
    "@draggable": ["boolean","false"],
    "@droppable": ["boolean","false"],
    "@enabled": ["boolean","true"],
    "@escapeHtml": ["boolean","true"],
    "@escapeTitleHtml": ["boolean","true"],
    "@escapeTooltipHtml": ["boolean","true"],
    "@help": "string",
    "@helpDisplay": ["string","conditional",["yes","conditional","no"]],
    "@invalid": ["boolean","false"],
    "@invalidState": ["string","error",["error","warning"]],
    "@invalidmessage": "string",
    "@tooltip": "string",
    "@tooltipDelay": "integer",
    "@visible": ["boolean","true"],
    "validation": {
      "@title": "string",
      "@forceValidation": ["boolean","false"],
      "@disableValidation": ["boolean","false"]
    },
    "@title": "string",
    "@titlePlacement": ["string","INV",["UL","L","LL","INV"]],
    "@titleWidth": "int",
    "@maxDropDownHeight": "string",
    "@activeKey": "string",
    "@focusedKey": "string",
    "@iconPlacement": ["string","left",["left","right"]],
    "@target": ["string",null,["blank","parent","top"]],
    "items*": {
      "key": "string",
      "title": "string",
      "icon": "string",
      "cssclass": "string",
      "css": "string",
      "url": "string",
      "tooltip": "string",
      "enabled": ["boolean","true"],
      "opened": ["boolean","false"],
      "openable": ["boolean","true"],
      "items*": {
        "key": "string",
        "title": "string",
        "icon": "string",
        "cssclass": "string",
        "css": "string",
        "url": "string",
        "tooltip": "string",
        "enabled": ["boolean","true"],
        "opened": ["boolean","false"],
        "openable": ["boolean","true"],
        "items*": {
          "key": "string",
          "title": "string",
          "icon": "string",
          "cssclass": "string",
          "css": "string",
          "url": "string",
          "tooltip": "string",
          "enabled": ["boolean","true"]
        }
      }
    }
  },
  "microphone": {
    "@readonly": ["boolean","false"],
    "validation": {
      "@required": ["boolean","false"],
      "@title": "string",
      "@forceValidation": ["boolean","false"],
      "@disableValidation": ["boolean","false"]
    },
    "@horizontalAlignment": ["string",null,["left","center","right"]],
    "value": "string",
    "@title": "string",
    "@titlePlacement": ["string","UL",["UL","L","LL","INV"]],
    "@titleWidth": "int",
    "@verticalAlignment": ["string","top",["bottom","middle","top"]],
    "@css": "string",
    "@cssClass": "string",
    "@cssClassField": "string",
    "@cssField": "string",
    "@data": "anyType",
    "@dragEnterDelay": ["integer","0"],
    "@dragImage": "string",
    "@dragOverDelay": ["integer","0"],
    "@draggable": ["boolean","false"],
    "@droppable": ["boolean","false"],
    "@enabled": ["boolean","true"],
    "@escapeHtml": ["boolean","true"],
    "@escapeTitleHtml": ["boolean","true"],
    "@escapeTooltipHtml": ["boolean","true"],
    "@help": "string",
    "@helpDisplay": ["string","conditional",["yes","conditional","no"]],
    "@invalid": ["boolean","false"],
    "@invalidState": ["string","error",["error","warning"]],
    "@invalidmessage": "string",
    "@tooltip": "string",
    "@tooltipDelay": "integer",
    "@visible": ["boolean","true"],
    "@icon": "string",
    "@mimeType": ["string","audio/webm"],
    "@state": "string",
    "@timeElapsed": "integer"
  },
  "objectinspector": {
    "@title": "string",
    "@titlePlacement": ["string","UL",["UL","L","LL","INV"]],
    "@titleWidth": "int",
    "@verticalAlignment": ["string","top",["bottom","middle","top"]],
    "@css": "string",
    "@cssClass": "string",
    "@cssClassField": "string",
    "@cssField": "string",
    "@data": "anyType",
    "@dragEnterDelay": ["integer","0"],
    "@dragImage": "string",
    "@dragOverDelay": ["integer","0"],
    "@draggable": ["boolean","false"],
    "@droppable": ["boolean","false"],
    "@enabled": ["boolean","true"],
    "@escapeHtml": ["boolean","true"],
    "@escapeTitleHtml": ["boolean","true"],
    "@escapeTooltipHtml": ["boolean","true"],
    "@help": "string",
    "@helpDisplay": ["string","conditional",["yes","conditional","no"]],
    "@invalid": ["boolean","false"],
    "@invalidState": ["string","error",["error","warning"]],
    "@invalidmessage": "string",
    "@tooltip": "string",
    "@tooltipDelay": "integer",
    "@visible": ["boolean","true"],
    "validation": {
      "@title": "string",
      "@forceValidation": ["boolean","false"],
      "@disableValidation": ["boolean","false"]
    },
    "@name": "string",
    "@value": "anyType"
  },
  "pagination": {
    "@dataEvent": "string",
    "@horizontalAlignment": ["string",null,["left","center","right"]],
    "@title": "string",
    "@titlePlacement": ["string","INV",["UL","L","LL","INV"]],
    "@titleWidth": "int",
    "@verticalAlignment": ["string","top",["bottom","middle","top"]],
    "@css": "string",
    "@cssClass": "string",
    "@cssClassField": "string",
    "@cssField": "string",
    "@data": "anyType",
    "@dragEnterDelay": ["integer","0"],
    "@dragImage": "string",
    "@dragOverDelay": ["integer","0"],
    "@draggable": ["boolean","false"],
    "@droppable": ["boolean","false"],
    "@enabled": ["boolean","true"],
    "@escapeHtml": ["boolean","true"],
    "@escapeTitleHtml": ["boolean","true"],
    "@escapeTooltipHtml": ["boolean","true"],
    "@help": "string",
    "@helpDisplay": ["string","conditional",["yes","conditional","no"]],
    "@invalid": ["boolean","false"],
    "@invalidState": ["string","error",["error","warning"]],
    "@invalidmessage": "string",
    "@tooltip": "string",
    "@tooltipDelay": "integer",
    "@visible": ["boolean","true"],
    "validation": {
      "@title": "string",
      "@forceValidation": ["boolean","false"],
      "@disableValidation": ["boolean","false"]
    },
    "settings": {
      "@defaultRowsPerPage": "integer",
      "@page": {

      },
      "@rows": "integer",
      "@rowsPerPageItems*": "integer",
      "@rowsPerPageSelector": ["boolean","false"],
      "@rowsPerPageSelectorAll": ["boolean","false"]
    }
  },
  "panel": {
    "@verticalAlignment": ["string","top",["bottom","middle","top"]],
    "@css": "string",
    "@cssClass": "string",
    "@cssClassField": "string",
    "@cssField": "string",
    "@data": "anyType",
    "@dragEnterDelay": ["integer","0"],
    "@dragImage": "string",
    "@dragOverDelay": ["integer","0"],
    "@draggable": ["boolean","false"],
    "@droppable": ["boolean","false"],
    "@enabled": ["boolean","true"],
    "@escapeHtml": ["boolean","true"],
    "@escapeTitleHtml": ["boolean","true"],
    "@escapeTooltipHtml": ["boolean","true"],
    "@help": "string",
    "@helpDisplay": ["string","conditional",["yes","conditional","no"]],
    "@invalid": ["boolean","false"],
    "@invalidState": ["string","error",["error","warning"]],
    "@invalidmessage": "string",
    "@tooltip": "string",
    "@tooltipDelay": "integer",
    "@visible": ["boolean","true"],
    "validation": {
      "@title": "string",
      "@forceValidation": ["boolean","false"],
      "@disableValidation": ["boolean","false"]
    },
    "@collapsed": ["boolean","false"],
    "@collapsible": ["boolean","false"],
    "@focused": ["boolean","false"],
    "@horizontalAlignment": ["string",null,["left","center","right"]],
    "@title": "string",
    "@titlePlacement": ["string","INV",["PI","UL","L","LL","INV"]],
    "@titleWidth": "int",
    "@icon": "string",
    "@iconPlacement": ["string","left",["left","right"]],
    "@readonly": ["boolean","false"],
    "@textmode": ["boolean","false"],
    "@customwidget": "string",
    "@sticky": ["boolean","false"],
    "@target": ["string",null,["blank","parent","top"]],
    "@url": "string"
  },
  "passwordbox": {
    "@verticalAlignment": ["string","top",["bottom","middle","top"]],
    "@css": "string",
    "@cssClass": "string",
    "@cssClassField": "string",
    "@cssField": "string",
    "@data": "anyType",
    "@dragEnterDelay": ["integer","0"],
    "@dragImage": "string",
    "@dragOverDelay": ["integer","0"],
    "@draggable": ["boolean","false"],
    "@droppable": ["boolean","false"],
    "@enabled": ["boolean","true"],
    "@escapeHtml": ["boolean","true"],
    "@escapeTitleHtml": ["boolean","true"],
    "@escapeTooltipHtml": ["boolean","true"],
    "@help": "string",
    "@helpDisplay": ["string","conditional",["yes","conditional","no"]],
    "@invalid": ["boolean","false"],
    "@invalidState": ["string","error",["error","warning"]],
    "@invalidmessage": "string",
    "@tooltip": "string",
    "@tooltipDelay": "integer",
    "@visible": ["boolean","true"],
    "validation": {
      "@title": "string",
      "@forceValidation": ["boolean","false"],
      "@disableValidation": ["boolean","false"],
      "@required": ["boolean","false"],
      "@minLength": "int",
      "@maxLength": "int",
      "@pattern": "string"
    },
    "@horizontalAlignment": ["string",null,["left","center","right"]],
    "@title": "string",
    "@titlePlacement": ["string","UL",["UL","L","LL","INV"]],
    "@titleWidth": "int",
    "@icon": "string",
    "@iconPlacement": ["string","left",["left","right"]],
    "@readonly": ["boolean","false"],
    "@focused": ["boolean","false"],
    "value": "string",
    "@textmode": ["boolean","false"],
    "@placeholder": "string",
    "@size": "integer",
    "@typingbreakDelay": ["integer","1000"]
  },
  "pdfjs": {
    "@verticalAlignment": ["string","top",["bottom","middle","top"]],
    "@css": "string",
    "@cssClass": "string",
    "@cssClassField": "string",
    "@cssField": "string",
    "@data": "anyType",
    "@dragEnterDelay": ["integer","0"],
    "@dragImage": "string",
    "@dragOverDelay": ["integer","0"],
    "@draggable": ["boolean","false"],
    "@droppable": ["boolean","false"],
    "@enabled": ["boolean","true"],
    "@escapeHtml": ["boolean","true"],
    "@escapeTitleHtml": ["boolean","true"],
    "@escapeTooltipHtml": ["boolean","true"],
    "@help": "string",
    "@helpDisplay": ["string","conditional",["yes","conditional","no"]],
    "@invalid": ["boolean","false"],
    "@invalidState": ["string","error",["error","warning"]],
    "@invalidmessage": "string",
    "@tooltip": "string",
    "@tooltipDelay": "integer",
    "@visible": ["boolean","true"],
    "validation": {
      "@title": "string",
      "@forceValidation": ["boolean","false"],
      "@disableValidation": ["boolean","false"]
    },
    "@title": "string",
    "@titlePlacement": ["string","UL",["UL","L","LL","INV"]],
    "@titleWidth": "int",
    "@fileName": "string",
    "@showAsLink": ["boolean","false"],
    "@url": "string",
    "value": "base64Binary",
    "@downloadButton": ["boolean","false"],
    "@multiPage": ["boolean","false"],
    "@height": "string",
    "@scaleTo100": ["boolean","false"]
  },
  "pdfviewer": {
    "@verticalAlignment": ["string","top",["bottom","middle","top"]],
    "@css": "string",
    "@cssClass": "string",
    "@cssClassField": "string",
    "@cssField": "string",
    "@data": "anyType",
    "@dragEnterDelay": ["integer","0"],
    "@dragImage": "string",
    "@dragOverDelay": ["integer","0"],
    "@draggable": ["boolean","false"],
    "@droppable": ["boolean","false"],
    "@enabled": ["boolean","true"],
    "@escapeHtml": ["boolean","true"],
    "@escapeTitleHtml": ["boolean","true"],
    "@escapeTooltipHtml": ["boolean","true"],
    "@help": "string",
    "@helpDisplay": ["string","conditional",["yes","conditional","no"]],
    "@invalid": ["boolean","false"],
    "@invalidState": ["string","error",["error","warning"]],
    "@invalidmessage": "string",
    "@tooltip": "string",
    "@tooltipDelay": "integer",
    "@visible": ["boolean","true"],
    "validation": {
      "@title": "string",
      "@forceValidation": ["boolean","false"],
      "@disableValidation": ["boolean","false"]
    },
    "@title": "string",
    "@titlePlacement": ["string","UL",["UL","L","LL","INV"]],
    "@titleWidth": "int",
    "@fileName": "string",
    "@showAsLink": ["boolean","false"],
    "@url": "string",
    "value": "base64Binary",
    "@height": "string"
  },
  "piechart": {
    "@verticalAlignment": ["string","top",["bottom","middle","top"]],
    "@css": "string",
    "@cssClass": "string",
    "@cssClassField": "string",
    "@cssField": "string",
    "@data": "anyType",
    "@dragEnterDelay": ["integer","0"],
    "@dragImage": "string",
    "@dragOverDelay": ["integer","0"],
    "@draggable": ["boolean","false"],
    "@droppable": ["boolean","false"],
    "@enabled": ["boolean","true"],
    "@escapeHtml": ["boolean","true"],
    "@escapeTitleHtml": ["boolean","true"],
    "@escapeTooltipHtml": ["boolean","true"],
    "@help": "string",
    "@helpDisplay": ["string","conditional",["yes","conditional","no"]],
    "@invalid": ["boolean","false"],
    "@invalidState": ["string","error",["error","warning"]],
    "@invalidmessage": "string",
    "@tooltip": "string",
    "@tooltipDelay": "integer",
    "@visible": ["boolean","true"],
    "validation": {
      "@title": "string",
      "@forceValidation": ["boolean","false"],
      "@disableValidation": ["boolean","false"]
    },
    "@title": "string",
    "@titlePlacement": ["string","UL",["UL","L","LL","INV"]],
    "@titleWidth": "int",
    "@cutoutPercentage": ["integer","0"],
    "@legendPosition": ["string",null,["top","bottom","left","right","none"]],
    "@maintainAspectRatio": ["boolean","true"],
    "@showChartTooltips": ["boolean","true"],
    "@valuesInsideChart": ["boolean","false"],
    "@valuesInsideChartColor": ["string","#FFFFFF"],
    "@valuesInsideChartFontFamily": "string",
    "@valuesInsideChartFontSize": ["integer","12"],
    "@valuesInsideChartFontStyle": ["string","normal"],
    "@valuesInsideChartFontWeight": ["string","normal"],
    "@valuesInsideChartFormatter": ["string",null,["percent","message"]],
    "@valuesInsideChartHideSmallerThan": "decimal",
    "@valuesInsideChartPosition": ["string","center",["center","end"]],
    "@valuesInsideChartformatPattern": "string",
    "values*": {
      "@name": "string",
      "@amount": "decimal",
      "@color": "string"
    }
  },
  "radiobutton": {
    "@verticalAlignment": ["string","top",["bottom","middle","top"]],
    "@css": "string",
    "@cssClass": "string",
    "@cssClassField": "string",
    "@cssField": "string",
    "@data": "anyType",
    "@dragEnterDelay": ["integer","0"],
    "@dragImage": "string",
    "@dragOverDelay": ["integer","0"],
    "@draggable": ["boolean","false"],
    "@droppable": ["boolean","false"],
    "@enabled": ["boolean","true"],
    "@escapeHtml": ["boolean","true"],
    "@escapeTitleHtml": ["boolean","true"],
    "@escapeTooltipHtml": ["boolean","true"],
    "@help": "string",
    "@helpDisplay": ["string","conditional",["yes","conditional","no"]],
    "@invalid": ["boolean","false"],
    "@invalidState": ["string","error",["error","warning"]],
    "@invalidmessage": "string",
    "@tooltip": "string",
    "@tooltipDelay": "integer",
    "@visible": ["boolean","true"],
    "validation": {
      "@title": "string",
      "@forceValidation": ["boolean","false"],
      "@disableValidation": ["boolean","false"]
    },
    "@focused": ["boolean","false"],
    "@horizontalAlignment": ["string",null,["left","center","right"]],
    "@readonly": ["boolean","false"],
    "value": "string",
    "@behavior": ["string",null,["submit","store","cancel","formlogic","url"]],
    "@confirm": ["boolean","false"],
    "@confirmMessage": "string",
    "@defaultAction": ["boolean","false"],
    "@title": "string",
    "@titlePlacement": ["string","R",["R","UL","L","LL","INV"]],
    "@titleWidth": "int"
  },
  "radiogroup": {
    "@verticalAlignment": ["string","top",["bottom","middle","top"]],
    "@css": "string",
    "@cssClass": "string",
    "@cssClassField": "string",
    "@cssField": "string",
    "@data": "anyType",
    "@dragEnterDelay": ["integer","0"],
    "@dragImage": "string",
    "@dragOverDelay": ["integer","0"],
    "@draggable": ["boolean","false"],
    "@droppable": ["boolean","false"],
    "@enabled": ["boolean","true"],
    "@escapeHtml": ["boolean","true"],
    "@escapeTitleHtml": ["boolean","true"],
    "@escapeTooltipHtml": ["boolean","true"],
    "@help": "string",
    "@helpDisplay": ["string","conditional",["yes","conditional","no"]],
    "@invalid": ["boolean","false"],
    "@invalidState": ["string","error",["error","warning"]],
    "@invalidmessage": "string",
    "@tooltip": "string",
    "@tooltipDelay": "integer",
    "@visible": ["boolean","true"],
    "validation": {
      "@title": "string",
      "@forceValidation": ["boolean","false"],
      "@disableValidation": ["boolean","false"],
      "@required": ["boolean","false"]
    },
    "@title": "string",
    "@titlePlacement": ["string","UL",["UL","L","LL","INV"]],
    "@titleWidth": "int",
    "@readonly": ["boolean","false"],
    "value": "string",
    "@textmode": ["boolean","false"],
    "@asButtons": ["boolean","false"]
  },
  "repeater": {
    "@verticalAlignment": ["string","top",["bottom","middle","top"]],
    "@css": "string",
    "@cssClass": "string",
    "@cssClassField": "string",
    "@cssField": "string",
    "@data": "anyType",
    "@dragEnterDelay": ["integer","0"],
    "@dragImage": "string",
    "@dragOverDelay": ["integer","0"],
    "@draggable": ["boolean","false"],
    "@droppable": ["boolean","false"],
    "@enabled": ["boolean","true"],
    "@escapeHtml": ["boolean","true"],
    "@escapeTitleHtml": ["boolean","true"],
    "@escapeTooltipHtml": ["boolean","true"],
    "@help": "string",
    "@helpDisplay": ["string","conditional",["yes","conditional","no"]],
    "@invalid": ["boolean","false"],
    "@invalidState": ["string","error",["error","warning"]],
    "@invalidmessage": "string",
    "@tooltip": "string",
    "@tooltipDelay": "integer",
    "@visible": ["boolean","true"],
    "validation": {
      "@title": "string",
      "@forceValidation": ["boolean","false"],
      "@disableValidation": ["boolean","false"]
    },
    "@collapsed": ["boolean","false"],
    "@collapsible": ["boolean","false"],
    "@readonly": ["boolean","false"],
    "@allRowsOutput": ["boolean","false"],
    "@count": "integer",
    "@positionReorderMode": ["boolean","false"],
    "rows*": {
      "@position": "integer",
      "@positionPrev": "integer",
      "@id": "string",
      "@cssClass": "string",
      "@css": "string",
      "@enabled": ["boolean","true"],
      "@readonly": ["boolean","false"],
      "@visible": ["boolean","true"],
      "@selected": ["boolean","false"],
      "@textmode": ["boolean","false"],
      "@draggable": ["boolean","false"],
      "@droppable": ["boolean","false"],
      "@data": "anyType"
    },
    "@title": "string",
    "@titlePlacement": ["string","UL",["UL","L","LL","INV"]],
    "@titleWidth": "int",
    "@textmode": ["boolean","false"],
    "@inline": ["boolean","false"],
    "@inlineAuto": ["boolean","false"],
    "@reorderingRows": ["boolean","false"],
    "@rowsReordered": ["boolean","false"]
  },
  "slider": {
    "@horizontalAlignment": ["string",null,["left","center","right"]],
    "@verticalAlignment": ["string","top",["bottom","middle","top"]],
    "@css": "string",
    "@cssClass": "string",
    "@cssClassField": "string",
    "@cssField": "string",
    "@data": "anyType",
    "@dragEnterDelay": ["integer","0"],
    "@dragImage": "string",
    "@dragOverDelay": ["integer","0"],
    "@draggable": ["boolean","false"],
    "@droppable": ["boolean","false"],
    "@enabled": ["boolean","true"],
    "@escapeHtml": ["boolean","true"],
    "@escapeTitleHtml": ["boolean","true"],
    "@escapeTooltipHtml": ["boolean","true"],
    "@help": "string",
    "@helpDisplay": ["string","conditional",["yes","conditional","no"]],
    "@invalid": ["boolean","false"],
    "@invalidState": ["string","error",["error","warning"]],
    "@invalidmessage": "string",
    "@tooltip": "string",
    "@tooltipDelay": "integer",
    "@visible": ["boolean","true"],
    "validation": {
      "@title": "string",
      "@forceValidation": ["boolean","false"],
      "@disableValidation": ["boolean","false"],
      "@required": ["boolean","false"],
      "@minLength": "int",
      "@maxLength": "int",
      "@pattern": "string",
      "@minValue": "data",
      "@maxValue": "data"
    },
    "@title": "string",
    "@titlePlacement": ["string","UL",["UL","L","LL","INV"]],
    "@titleWidth": "int",
    "@icon": "string",
    "@iconPlacement": ["string","left",["left","right"]],
    "@readonly": ["boolean","false"],
    "@focused": ["boolean","false"],
    "value": "data",
    "@textmode": ["boolean","false"],
    "@placeholder": "string",
    "@size": "integer",
    "@decimalScale": "integer",
    "@disableFormatOnEdit": ["boolean","false"],
    "@formatPattern": "string",
    "@formatType": ["string",null,["number","mask"]],
    "@prefix": "string",
    "@suffix": "string",
    "@typingbreakDelay": ["integer","1000"],
    "@type": ["string",null,["color","date","datetime-local","email","month","time","url","week"]],
    "@adjustOutOfRange": ["boolean","false"],
    "@leftText": "string",
    "@max": ["decimal","100"],
    "@min": ["decimal","0"],
    "@reversed": ["boolean","false"],
    "@rightText": "string",
    "@showAsStepper": ["boolean","false"],
    "@step": "data",
    "@valuePosition": ["string","right",["left","top","right","bottom"]],
    "@valueStyle": ["string","none",["none","readonly","textbox"]],
    "@valueTooltip": ["boolean","false"]
  },
  "steps": {
    "@behavior": ["string",null,["submit","store","cancel","formlogic","url"]],
    "@confirm": ["boolean","false"],
    "@confirmMessage": "string",
    "@defaultAction": ["boolean","false"],
    "@title": "string",
    "@titlePlacement": ["string","INV",["UL","L","LL","INV"]],
    "@titleWidth": "int",
    "@css": "string",
    "@cssClass": "string",
    "@cssClassField": "string",
    "@cssField": "string",
    "@activeIndex": "integer",
    "@ordered": ["boolean","false"],
    "@visible": ["boolean","true"],
    "step*": {
      "@key": "string",
      "@title": "string",
      "@description": "string",
      "@icon": "string",
      "@url": "string",
      "@enabled": ["boolean","true"]
    },
    "value": "date"
  },
  "table": {
    "@verticalAlignment": ["string","top",["bottom","middle","top"]],
    "@css": "string",
    "@cssClass": "string",
    "@cssClassField": "string",
    "@cssField": "string",
    "@data": "anyType",
    "@dragEnterDelay": ["integer","0"],
    "@dragImage": "string",
    "@dragOverDelay": ["integer","0"],
    "@draggable": ["boolean","false"],
    "@droppable": ["boolean","false"],
    "@enabled": ["boolean","true"],
    "@escapeHtml": ["boolean","true"],
    "@escapeTitleHtml": ["boolean","true"],
    "@escapeTooltipHtml": ["boolean","true"],
    "@help": "string",
    "@helpDisplay": ["string","conditional",["yes","conditional","no"]],
    "@invalid": ["boolean","false"],
    "@invalidState": ["string","error",["error","warning"]],
    "@invalidmessage": "string",
    "@tooltip": "string",
    "@tooltipDelay": "integer",
    "@visible": ["boolean","true"],
    "validation": {
      "@title": "string",
      "@forceValidation": ["boolean","false"],
      "@disableValidation": ["boolean","false"]
    },
    "@dataEvent": "string",
    "@readonly": ["boolean","false"],
    "@allRowsOutput": ["boolean","false"],
    "@count": "integer",
    "@positionReorderMode": ["boolean","false"],
    "rows*": {
      "@position": "integer",
      "@positionPrev": "integer",
      "@id": "string",
      "@cssClass": "string",
      "@css": "string",
      "@enabled": ["boolean","true"],
      "@readonly": ["boolean","false"],
      "@visible": ["boolean","true"],
      "@selected": ["boolean","false"],
      "@textmode": ["boolean","false"],
      "@draggable": ["boolean","false"],
      "@droppable": ["boolean","false"],
      "@data": "anyType",
      "columns": {
        "@colspan": "integer",
        "@rowspan": "integer"
      }
    },
    "@title": "string",
    "@titlePlacement": ["string","UL",["UL","L","LL","INV"]],
    "@titleWidth": "int",
    "@textmode": ["boolean","false"],
    "columns": {
      "@title": "string",
      "@visible": ["boolean","true"],
      "@sortable": ["boolean","false"],
      "@layoutVisible": ["string",null,["large","medium large","small medium large","x-small small medium large"]],
      "@sorted": ["boolean","false"],
      "@ascending": ["boolean","true"],
      "filterField": "field",
      "@filterable": ["boolean","true"],
      "@filterValue*": "string",
      "@filterType": ["string","textbox",["textbox","combobox","datebox"]],
      "@filterByRange": "boolean",
      "@filterOperatorSelector": ["boolean","false"],
      "@filterOperatorValue": ["string","="],
      "filterOperatorItem*": {
        "@key": "string",
        "@title": "string"
      },
      "@filterBasicType": ["string",null,["integer","decimal","time","date","dateTime"]],
      "@filterPlaceholder*": "string",
      "item*": {
        "@key": "string",
        "@title": "string"
      },
      "@ellipsisText": ["boolean","false"],
      "@minWidth": "int",
      "@width": "string",
      "@percentWidth": "int",
      "@group": "string",
      "@collapsing": ["boolean","false"],
      "@escapeTitleHtml": ["boolean","true"],
      "@nowrap": ["boolean","false"],
      "@tooltip": "string",
      "@position": "integer"
    },
    "settings": {
      "@headAlign": ["string",null,["left","center","right"]],
      "@showFilterRow": ["boolean","false"],
      "@noRowText": "string",
      "@fixed": ["boolean","false"],
      "@selector": ["string",null,["left","right"]],
      "@selectedAll": ["boolean","false"],
      "@scrollableHorizontal": ["boolean","false"],
      "@hideHeader": ["boolean","false"],
      "@collapsing": ["boolean","false"],
      "@reorderingRows": ["boolean","false"],
      "@rowsReordered": ["boolean","false"],
      "@reorderingColumns": ["boolean","false"],
      "@resizingColumns": ["boolean","false"],
      "@columnsReordered": ["boolean","false"],
      "@columnsResized": ["boolean","false"],
      "@stickyHeader": ["boolean","false"]
    }
  },
  "tabpanel": {
    "@verticalAlignment": ["string","top",["bottom","middle","top"]],
    "@css": "string",
    "@cssClass": "string",
    "@cssClassField": "string",
    "@cssField": "string",
    "@data": "anyType",
    "@dragEnterDelay": ["integer","0"],
    "@dragImage": "string",
    "@dragOverDelay": ["integer","0"],
    "@draggable": ["boolean","false"],
    "@droppable": ["boolean","false"],
    "@enabled": ["boolean","true"],
    "@escapeHtml": ["boolean","true"],
    "@escapeTitleHtml": ["boolean","true"],
    "@escapeTooltipHtml": ["boolean","true"],
    "@help": "string",
    "@helpDisplay": ["string","conditional",["yes","conditional","no"]],
    "@invalid": ["boolean","false"],
    "@invalidState": ["string","error",["error","warning"]],
    "@invalidmessage": "string",
    "@tooltip": "string",
    "@tooltipDelay": "integer",
    "@visible": ["boolean","true"],
    "validation": {
      "@title": "string",
      "@forceValidation": ["boolean","false"],
      "@disableValidation": ["boolean","false"]
    },
    "@readonly": ["boolean","false"],
    "@title": "string",
    "@titlePlacement": ["string","UL",["UL","L","LL","INV"]],
    "@titleWidth": "int",
    "@activeIndex": ["int","0"],
    "@fluid": ["boolean","false"],
    "@theme": ["string","tabs",["tabs","pills","underlines"]]
  },
  "textarea": {
    "@verticalAlignment": ["string","top",["bottom","middle","top"]],
    "@css": "string",
    "@cssClass": "string",
    "@cssClassField": "string",
    "@cssField": "string",
    "@data": "anyType",
    "@dragEnterDelay": ["integer","0"],
    "@dragImage": "string",
    "@dragOverDelay": ["integer","0"],
    "@draggable": ["boolean","false"],
    "@droppable": ["boolean","false"],
    "@enabled": ["boolean","true"],
    "@escapeHtml": ["boolean","true"],
    "@escapeTitleHtml": ["boolean","true"],
    "@escapeTooltipHtml": ["boolean","true"],
    "@help": "string",
    "@helpDisplay": ["string","conditional",["yes","conditional","no"]],
    "@invalid": ["boolean","false"],
    "@invalidState": ["string","error",["error","warning"]],
    "@invalidmessage": "string",
    "@tooltip": "string",
    "@tooltipDelay": "integer",
    "@visible": ["boolean","true"],
    "validation": {
      "@title": "string",
      "@forceValidation": ["boolean","false"],
      "@disableValidation": ["boolean","false"],
      "@required": ["boolean","false"],
      "@minLength": "int",
      "@maxLength": "int",
      "@pattern": "string"
    },
    "@focused": ["boolean","false"],
    "value": "string",
    "@readonly": ["boolean","false"],
    "@title": "string",
    "@titlePlacement": ["string","UL",["UL","L","LL","INV"]],
    "@titleWidth": "int",
    "@textmode": ["boolean","false"],
    "@typingbreakDelay": ["integer","1000"],
    "@nowrap": ["boolean","false"],
    "@placeholder": "string",
    "@resize": ["boolean","false"],
    "@rows": "int"
  },
  "textbox": {
    "@autocomplete": "string",
    "@horizontalAlignment": ["string",null,["left","center","right"]],
    "@verticalAlignment": ["string","top",["bottom","middle","top"]],
    "@css": "string",
    "@cssClass": "string",
    "@cssClassField": "string",
    "@cssField": "string",
    "@data": "anyType",
    "@dragEnterDelay": ["integer","0"],
    "@dragImage": "string",
    "@dragOverDelay": ["integer","0"],
    "@draggable": ["boolean","false"],
    "@droppable": ["boolean","false"],
    "@enabled": ["boolean","true"],
    "@escapeHtml": ["boolean","true"],
    "@escapeTitleHtml": ["boolean","true"],
    "@escapeTooltipHtml": ["boolean","true"],
    "@help": "string",
    "@helpDisplay": ["string","conditional",["yes","conditional","no"]],
    "@invalid": ["boolean","false"],
    "@invalidState": ["string","error",["error","warning"]],
    "@invalidmessage": "string",
    "@tooltip": "string",
    "@tooltipDelay": "integer",
    "@visible": ["boolean","true"],
    "validation": {
      "@title": "string",
      "@forceValidation": ["boolean","false"],
      "@disableValidation": ["boolean","false"],
      "@required": ["boolean","false"],
      "@minLength": "int",
      "@maxLength": "int",
      "@pattern": "string",
      "@minValue": "data",
      "@maxValue": "data"
    },
    "@title": "string",
    "@titlePlacement": ["string","UL",["UL","L","LL","INV"]],
    "@titleWidth": "int",
    "@icon": "string",
    "@iconPlacement": ["string","left",["left","right"]],
    "@readonly": ["boolean","false"],
    "@focused": ["boolean","false"],
    "value": "data",
    "@textmode": ["boolean","false"],
    "@placeholder": "string",
    "@size": "integer",
    "@decimalScale": "integer",
    "@disableFormatOnEdit": ["boolean","false"],
    "@formatPattern": "string",
    "@formatType": ["string",null,["number","mask"]],
    "@prefix": "string",
    "@suffix": "string",
    "@typingbreakDelay": ["integer","1000"],
    "@type": ["string",null,["color","date","datetime-local","email","month","time","url","week"]]
  },
  "unitbox": {
    "@horizontalAlignment": ["string",null,["left","center","right"]],
    "@verticalAlignment": ["string","top",["bottom","middle","top"]],
    "@css": "string",
    "@cssClass": "string",
    "@cssClassField": "string",
    "@cssField": "string",
    "@data": "anyType",
    "@dragEnterDelay": ["integer","0"],
    "@dragImage": "string",
    "@dragOverDelay": ["integer","0"],
    "@draggable": ["boolean","false"],
    "@droppable": ["boolean","false"],
    "@enabled": ["boolean","true"],
    "@escapeHtml": ["boolean","true"],
    "@escapeTitleHtml": ["boolean","true"],
    "@escapeTooltipHtml": ["boolean","true"],
    "@help": "string",
    "@helpDisplay": ["string","conditional",["yes","conditional","no"]],
    "@invalid": ["boolean","false"],
    "@invalidState": ["string","error",["error","warning"]],
    "@invalidmessage": "string",
    "@tooltip": "string",
    "@tooltipDelay": "integer",
    "@visible": ["boolean","true"],
    "validation": {
      "@title": "string",
      "@forceValidation": ["boolean","false"],
      "@disableValidation": ["boolean","false"],
      "@required": ["boolean","false"],
      "@minLength": "int",
      "@maxLength": "int",
      "@pattern": "string",
      "@minValue": "data",
      "@maxValue": "data"
    },
    "@title": "string",
    "@titlePlacement": ["string","UL",["UL","L","LL","INV"]],
    "@titleWidth": "int",
    "@icon": "string",
    "@iconPlacement": ["string","left",["left","right"]],
    "@readonly": ["boolean","false"],
    "@focused": ["boolean","false"],
    "value": "data",
    "@textmode": ["boolean","false"],
    "@placeholder": "string",
    "@size": "integer",
    "@decimalScale": "integer",
    "@disableFormatOnEdit": ["boolean","false"],
    "@formatPattern": "string",
    "@formatType": ["string",null,["number","mask"]],
    "@prefix": "string",
    "@suffix": "string",
    "@typingbreakDelay": ["integer","1000"],
    "@type": ["string",null,["color","date","datetime-local","email","month","time","url","week"]],
    "@unit": "string",
    "@unitPlacement": ["string","right",["right","left"]]
  },
  "unitcombobox": {
    "items*": {
      "@key": "string",
      "@title": "string",
      "@group": "string",
      "@icon": "string",
      "@imageUrl": "string",
      "@url": "string",
      "@enabled": "boolean",
      "@cssClass": "string",
      "@css": "string"
    },
    "defaultItems*": {
      "@key": "string",
      "@title": "string"
    },
    "@horizontalAlignment": ["string",null,["left","center","right"]],
    "@verticalAlignment": ["string","top",["bottom","middle","top"]],
    "@css": "string",
    "@cssClass": "string",
    "@cssClassField": "string",
    "@cssField": "string",
    "@data": "anyType",
    "@dragEnterDelay": ["integer","0"],
    "@dragImage": "string",
    "@dragOverDelay": ["integer","0"],
    "@draggable": ["boolean","false"],
    "@droppable": ["boolean","false"],
    "@enabled": ["boolean","true"],
    "@escapeHtml": ["boolean","true"],
    "@escapeTitleHtml": ["boolean","true"],
    "@escapeTooltipHtml": ["boolean","true"],
    "@help": "string",
    "@helpDisplay": ["string","conditional",["yes","conditional","no"]],
    "@invalid": ["boolean","false"],
    "@invalidState": ["string","error",["error","warning"]],
    "@invalidmessage": "string",
    "@tooltip": "string",
    "@tooltipDelay": "integer",
    "@visible": ["boolean","true"],
    "validation": {
      "@title": "string",
      "@forceValidation": ["boolean","false"],
      "@disableValidation": ["boolean","false"],
      "@required": ["boolean","false"],
      "@minLength": "int",
      "@maxLength": "int",
      "@pattern": "string",
      "@minValue": "data",
      "@maxValue": "data"
    },
    "@title": "string",
    "@titlePlacement": ["string","UL",["UL","L","LL","INV"]],
    "@titleWidth": "int",
    "@icon": "string",
    "@iconPlacement": ["string","left",["left","right"]],
    "@readonly": ["boolean","false"],
    "@focused": ["boolean","false"],
    "value": "data",
    "@textmode": ["boolean","false"],
    "@placeholder": "string",
    "@size": "integer",
    "@decimalScale": "integer",
    "@disableFormatOnEdit": ["boolean","false"],
    "@formatPattern": "string",
    "@formatType": ["string",null,["number","mask"]],
    "@prefix": "string",
    "@suffix": "string",
    "@typingbreakDelay": ["integer","1000"],
    "@type": ["string",null,["color","date","datetime-local","email","month","time","url","week"]],
    "@clearable": ["boolean","false"],
    "@unit": "string",
    "@unitPlacement": ["string","right",["right","left"]]
  },
  "upload": {
    "@verticalAlignment": ["string","top",["bottom","middle","top"]],
    "@css": "string",
    "@cssClass": "string",
    "@cssClassField": "string",
    "@cssField": "string",
    "@data": "anyType",
    "@dragEnterDelay": ["integer","0"],
    "@dragImage": "string",
    "@dragOverDelay": ["integer","0"],
    "@draggable": ["boolean","false"],
    "@droppable": ["boolean","false"],
    "@enabled": ["boolean","true"],
    "@escapeHtml": ["boolean","true"],
    "@escapeTitleHtml": ["boolean","true"],
    "@escapeTooltipHtml": ["boolean","true"],
    "@help": "string",
    "@helpDisplay": ["string","conditional",["yes","conditional","no"]],
    "@invalid": ["boolean","false"],
    "@invalidState": ["string","error",["error","warning"]],
    "@invalidmessage": "string",
    "@tooltip": "string",
    "@tooltipDelay": "integer",
    "@visible": ["boolean","true"],
    "validation": {
      "@title": "string",
      "@forceValidation": ["boolean","false"],
      "@disableValidation": ["boolean","false"],
      "@required": ["boolean","false"]
    },
    "@readonly": ["boolean","false"],
    "@focused": ["boolean","false"],
    "@horizontalAlignment": ["string",null,["left","center","right"]],
    "@title": "string",
    "@titlePlacement": ["string","UL",["UL","L","LL","INV"]],
    "@titleWidth": "int",
    "@icon": "string",
    "@iconPlacement": ["string","left",["left","right"]],
    "@behavior": "string",
    "@confirm": ["boolean","false"],
    "@confirmMessage": "string",
    "@defaultAction": ["boolean","false"],
    "@accept": "string",
    "@buttonTitle": "string",
    "@directory": ["boolean","false"],
    "@dropZoneHeight": ["string","200px"],
    "@fileCountLimit": "integer",
    "@fileSizeLimit": "string",
    "@multiple": ["boolean","false"],
    "@nextPart": ["boolean","false"],
    "@partSize": "integer",
    "@placeholder": "string",
    "@showAsDropZone": ["boolean","false"],
    "part": {
      "@data": "base64Binary",
      "@size": "integer",
      "@number": "integer",
      "@totalParts": "integer",
      "@fileIndex": "integer"
    },
    "value*": {
      "@fileName": "string",
      "@contentType": "string",
      "@size": "integer",
      "@data": "base64Binary",
      "@relativePath": "string"
    }
  },
  "vbox": {
    "@verticalAlignment": ["string","top",["bottom","middle","top"]],
    "@css": "string",
    "@cssClass": "string",
    "@cssClassField": "string",
    "@cssField": "string",
    "@data": "anyType",
    "@dragEnterDelay": ["integer","0"],
    "@dragImage": "string",
    "@dragOverDelay": ["integer","0"],
    "@draggable": ["boolean","false"],
    "@droppable": ["boolean","false"],
    "@enabled": ["boolean","true"],
    "@escapeHtml": ["boolean","true"],
    "@escapeTitleHtml": ["boolean","true"],
    "@escapeTooltipHtml": ["boolean","true"],
    "@help": "string",
    "@helpDisplay": ["string","conditional",["yes","conditional","no"]],
    "@invalid": ["boolean","false"],
    "@invalidState": ["string","error",["error","warning"]],
    "@invalidmessage": "string",
    "@tooltip": "string",
    "@tooltipDelay": "integer",
    "@visible": ["boolean","true"],
    "validation": {
      "@title": "string",
      "@forceValidation": ["boolean","false"],
      "@disableValidation": ["boolean","false"]
    },
    "@collapsed": ["boolean","false"],
    "@collapsible": ["boolean","false"],
    "@readonly": ["boolean","false"],
    "@title": "string",
    "@titlePlacement": ["string","UL",["UL","L","LL","INV"]],
    "@titleWidth": "int",
    "@textmode": ["boolean","false"],
    "@fitWidth": ["boolean","false"],
    "@grouped": ["boolean","false"]
  },
  "videoviewer": {
    "@verticalAlignment": ["string","top",["bottom","middle","top"]],
    "@css": "string",
    "@cssClass": "string",
    "@cssClassField": "string",
    "@cssField": "string",
    "@data": "anyType",
    "@dragEnterDelay": ["integer","0"],
    "@dragImage": "string",
    "@dragOverDelay": ["integer","0"],
    "@draggable": ["boolean","false"],
    "@droppable": ["boolean","false"],
    "@enabled": ["boolean","true"],
    "@escapeHtml": ["boolean","true"],
    "@escapeTitleHtml": ["boolean","true"],
    "@escapeTooltipHtml": ["boolean","true"],
    "@help": "string",
    "@helpDisplay": ["string","conditional",["yes","conditional","no"]],
    "@invalid": ["boolean","false"],
    "@invalidState": ["string","error",["error","warning"]],
    "@invalidmessage": "string",
    "@tooltip": "string",
    "@tooltipDelay": "integer",
    "@visible": ["boolean","true"],
    "validation": {
      "@title": "string",
      "@forceValidation": ["boolean","false"],
      "@disableValidation": ["boolean","false"]
    },
    "@title": "string",
    "@titlePlacement": ["string","UL",["UL","L","LL","INV"]],
    "@titleWidth": "int",
    "@fileName": "string",
    "@showAsLink": ["boolean","false"],
    "@url": "string",
    "value": "base64Binary",
    "@autoplay": ["boolean","false"],
    "@contentType": "string",
    "@controls": ["boolean","false"],
    "@loop": ["boolean","false"],
    "@muted": ["boolean","false"]
  },
  "whisperbox": {
    "@readonly": ["boolean","false"],
    "validation": {
      "@required": ["boolean","false"],
      "@minLength": "int",
      "@maxLength": "int",
      "@pattern": "string",
      "@title": "string",
      "@forceValidation": ["boolean","false"],
      "@disableValidation": ["boolean","false"]
    },
    "@verticalAlignment": ["string","top",["bottom","middle","top"]],
    "@css": "string",
    "@cssClass": "string",
    "@cssClassField": "string",
    "@cssField": "string",
    "@data": "anyType",
    "@dragEnterDelay": ["integer","0"],
    "@dragImage": "string",
    "@dragOverDelay": ["integer","0"],
    "@draggable": ["boolean","false"],
    "@droppable": ["boolean","false"],
    "@enabled": ["boolean","true"],
    "@escapeHtml": ["boolean","true"],
    "@escapeTitleHtml": ["boolean","true"],
    "@escapeTooltipHtml": ["boolean","true"],
    "@help": "string",
    "@helpDisplay": ["string","conditional",["yes","conditional","no"]],
    "@invalid": ["boolean","false"],
    "@invalidState": ["string","error",["error","warning"]],
    "@invalidmessage": "string",
    "@tooltip": "string",
    "@tooltipDelay": "integer",
    "@visible": ["boolean","true"],
    "@focused": ["boolean","false"],
    "value": "string",
    "@title": "string",
    "@titlePlacement": ["string","UL",["UL","L","LL","INV"]],
    "@titleWidth": "int",
    "@textmode": ["boolean","false"],
    "@placeholder": "string",
    "@size": "integer",
    "@icon": "string",
    "@iconPlacement": ["string","left",["left","right"]],
    "@typingbreakDelay": ["integer","1000"],
    "@maxDropDownHeight": "string",
    "@forceSearch": {

    },
    "@forceValue": "boolean",
    "@whisperType": ["string","label",["label","value","both"]],
    "items*": {
      "@title": "string",
      "@key": "string",
      "@titleHtml": "string"
    },
    "defaultItems*": {
      "@key": "string",
      "@title": "string"
    },
    "text": "string"
  }
}

const Widgets = {
  get: function(widgetName) {
    return data[widgetName] ? data[widgetName] : false
  },
  getType: function(defStr) {
    return MC.asArray(defStr)[0]
  }
}

export default Widgets